export enum BusStopType {
    Morning = 0,
    Afternoon = 1,
    Other = 2
}
